if ($(window).width() > 1366){ 

    $(window).on("scroll", () => {
        $("[data-touching1]").each(function () {
            var className = $(this).attr("data-touching1");
            var offset = $(this).offset().top - $(window).scrollTop();
            if (offset <= 300) {
                $(this).addClass("in");
            }
            else{
                $(this).removeClass("in");
            }
        });
        $("[data-touching2]").each(function () {
            var className = $(this).attr("data-touching2");
            var offset = $(this).offset().top - $(window).scrollTop();
            if (offset <= 600) {
                $(this).addClass("in");
            }
        });
    }).trigger("scroll");

$(".text-up").each(function () {
    $(this).wrap('<div class="reveal-text-cover"><div class="reveal-text"></div></div>');
});
const revealTexts = document.querySelectorAll(".reveal-text");
revealTexts.forEach((revealText) => {
    gsap.set(revealText, { y: 120, opacity: 0 });
    gsap.to(revealText, {
        duration: 1,
        y: 0,
        opacity: 1,
        ease: Power3.easeOut,
        scrollTrigger: {
            trigger: revealText,
            start: "top 90%",
            toggleActions: "play none none reverse"
        }
    });
});
    
(function ($) {
    ("use strict");
    //GSAP scrollTrigger
    gsap.registerPlugin(ScrollTrigger);

    let animationRotate = document.querySelectorAll(".animation-rotate");
    animationRotate.forEach((animationRotate) => {
        gsap.to(animationRotate, {
            duration: 2,
            rotation: 360,
            ease: "linear",
            repeat: -1
        });
    });
        
    let scrollRotate = document.querySelectorAll(".scroll-rotate");
    scrollRotate.forEach((scrollRotate) => {
        gsap.to(scrollRotate, {
            scrollTrigger: {
                trigger: scrollRotate,
                scrub: 2
            },
            rotation: 720
        });
    });

    let scrollMoveRight = document.querySelectorAll(".scroll-move-right");
    scrollMoveRight.forEach((scrollMoveRight) => {
        gsap.to(scrollMoveRight, {
            x: 400,
            duration: 1,
            scrollTrigger: {
                trigger: scrollMoveRight,
                start: "top 50%",
                scrub: 2
            }
        });
    });

    let scrollMoveLeft = document.querySelectorAll(".scroll-move-left");
    scrollMoveLeft.forEach((scrollMoveLeft) => {
        gsap.to(scrollMoveLeft, {
            x: -250,
            duration: 1,
            scrollTrigger: {
                trigger: scrollMoveLeft,
                start: "top 50%",
                scrub: 2
            }
        });
    });

    let scrollMoveRight2 = document.querySelectorAll(".scroll-move-right2");
    scrollMoveRight2.forEach((scrollMoveRight2) => {
        gsap.to(scrollMoveRight2, {
            x: 800,
            duration: 1.5,
            scrollTrigger: {
                trigger: scrollMoveRight2,
                start: "top 100%",
                scrub: 2
            }
        });
    });

    let scrollMoveLeft2 = document.querySelectorAll(".scroll-move-left2");
    scrollMoveLeft2.forEach((scrollMoveLeft2) => {
        gsap.to(scrollMoveLeft2, {
            x: -400,
            duration: 1.5,
            scrollTrigger: {
                trigger: scrollMoveLeft2,
                start: "top 100%",
                scrub: 2
            }
        });
    });
    
    let aboutblueberry = document.querySelectorAll(".aboutblueberry");
    aboutblueberry.forEach((aboutblueberry) => {
        gsap.to(aboutblueberry, {
            y: 0,
            duration: 1,
            scrollTrigger: {
                trigger: aboutblueberry,
                start: "top 30%",
                scrub: 2
            }
        });
    }); 
    
    let scrollMoveUp = document.querySelectorAll(".scroll-move-up");
    scrollMoveUp.forEach((scrollMoveUp) => {
        gsap.to(scrollMoveUp, {
            y: 100,
            duration: 1,
            scrollTrigger: {
                trigger: scrollMoveUp,
                start: "top 50%",
                scrub: 2
            }
        });
    }); 
    
    let imgupmove = document.querySelectorAll(".imgupmove");
    
    let growUp = document.querySelectorAll(".grow-up");
    growUp.forEach((growUp) => {
        gsap.fromTo(
                growUp,
                {
                    autoAlpha: 0.5,
                    scale: 0.7
                },
                {
                    autoAlpha: 1,
                    duration: 2,
                    scale: 1,
                    scrollTrigger: {
                        trigger: growUp,
                        start: "top 90%"
                    },
                    stagger: 0.2
                }
        );
    });

    let bannerimgscrollZoomIn = document.querySelectorAll(".banner__media img:nth-child(1)");
    bannerimgscrollZoomIn.forEach((bannerimgscrollZoomIn) => {
        gsap.to(bannerimgscrollZoomIn, {
            scrollTrigger: {
                trigger: bannerimgscrollZoomIn,
                start: "top 0%",
                scrub: 1
            },
            scale: 1.3
        });
    });

    let scrollZoomIn = document.querySelectorAll(".scroll-zoom-in");
    scrollZoomIn.forEach((scrollZoomIn) => {
        gsap.to(scrollZoomIn, {
            scrollTrigger: {
                trigger: scrollZoomIn,
                start: "top 50%",
                scrub: 1
            },
            scale: 1.1
        });
    });

    let watercoconut = document.querySelectorAll(".watercoconut");
    watercoconut.forEach((watercoconut) => {
        gsap.to(watercoconut, {
            scrollTrigger: {
                trigger: watercoconut,
                start: "top 100%",
                scrub: 2
            },
            scale: 1
        });
    });

    let scrollZoomIn2 = document.querySelectorAll(".scroll-zoom-in-2");
    scrollZoomIn2.forEach((scrollZoomIn2) => {
        gsap.to(scrollZoomIn2, {
            scrollTrigger: {
                trigger: scrollZoomIn2,
                start: "top 100%",
                scrub: 2
            },
            scale: 1
        });
    });

    let scrollZoomOut = document.querySelectorAll(".scroll-zoom-out");
    scrollZoomOut.forEach((scrollZoomOut) => {
        gsap.to(scrollZoomOut, {
            scrollTrigger: {
                trigger: scrollZoomOut,
                start: "top 50%",
                scrub: 2
            },
            scale: 0.5
        });
    });

    /********/

    $(".text-opacity-top").each(function () {
        var words = $(this).text().split(" ");
        var total = words.length;
        $(this).empty();
        for (index = 0; index < total; index++) {
            $(this).append($("<span /> ").text(words[index] + " "));
        }
    });

    var TextOpacity = gsap.utils.toArray(".text-opacity-top");
    TextOpacity.forEach(function (TextOpacity) {
        var spanOpacity = TextOpacity.querySelectorAll("span");
        gsap.to(spanOpacity, {
            scrollTrigger: {
                trigger: TextOpacity,
                start: "top 40%",
                end: () => `+=${TextOpacity.offsetHeight}`,
                scrub: 1
            },
            duration: 1,
            opacity: 1,
            stagger: 0.5,
            ease: Linear.easeNone
        });
    });

    $(".text-opacity").each(function () {
        var words = $(this).text().split(" ");
        var total = words.length;
        $(this).empty();
        for (index = 0; index < total; index++) {
            $(this).append($("<span /> ").text(words[index] + " "));
        }
    });

    var TextOpacity = gsap.utils.toArray(".text-opacity");
    TextOpacity.forEach(function (TextOpacity) {
        var spanOpacity = TextOpacity.querySelectorAll("span");
        gsap.to(spanOpacity, {
            scrollTrigger: {
                trigger: TextOpacity,
                start: "top 60%",
                end: () => `+=${TextOpacity.offsetHeight}`,
                scrub: 1
            },
            duration: 1,
            opacity: 1,
            stagger: 0.5,
            ease: Linear.easeNone
        });
    });

    let scrollrotatereverse = document.querySelectorAll(".scroll-rotate-reverse");
    scrollrotatereverse.forEach((scrollrotatereverse) => {
        gsap.to(scrollrotatereverse, {
            scrollTrigger: {
                trigger: scrollrotatereverse,
                start: "top 20%",
                scrub: 2
            },
            rotation: -50
        });
    });
    
})(jQuery); 
}
/************/